import { required, maxLength, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

const t = (k) => i18n.global.t(k);
const filled = (v) => v !== '' && v !== null && v !== undefined;

// type-aware: tiered_reward (reward/threshold) vs item_discount (discount_mode/value)
export default function (form) {
  const isItemDiscount = () => form.type === 'item_discount';
  const isTiered = () => form.type === 'tiered_reward';

  return {
    form: {
      name: {
        required: helpers.withMessage(() => t('_promotion.Please enter a promotion name'), required),
        maxLength: helpers.withMessage(
          ({ $params }) => t('Name cannot exceed') + ' ' + $params.max + ' ' + t('characters.'),
          maxLength(255)
        ),
      },
      description: {},
      tier_mode: {
        required: helpers.withMessage(() => t('_promotion.Please select a tier mode'), required),
      },
      priority: {
        minValue: helpers.withMessage(() => t('_promotion.Value must be at least 0'), minValue(0)),
      },
      items: {
        atLeastOne: helpers.withMessage(() => t('_promotion.Add at least one tier'), (v) => Array.isArray(v) && v.length > 0),
        $each: helpers.forEach({
          // reward — tiered_reward เท่านั้น
          reward_product_id: {
            required: helpers.withMessage(() => t('_promotion.Select a reward product'), (v) => ! isTiered() || filled(v)),
          },
          minimum_spend: {
            okWhenSpend: helpers.withMessage(
              () => t('_promotion.Value must be at least 0'),
              (v, sib) => ! isTiered() || sib.condition_type !== 'spend' || (filled(v) && Number(v) >= 0)
            ),
          },
          buy_quantity: {
            okWhenQty: helpers.withMessage(
              () => t('_promotion.Value must be at least 0'),
              (v, sib) => ! isTiered() || sib.condition_type !== 'quantity' || (filled(v) && Number(v) >= 0)
            ),
          },
          free_quantity: {
            atLeastOne: helpers.withMessage(() => t('_promotion.Quantity must be at least 1'), (v) => ! isTiered() || (filled(v) && Number(v) >= 1)),
          },
          reward_price: {
            okWhenPwp: helpers.withMessage(
              () => t('_promotion.Enter reward price'),
              (v, sib) => ! isTiered() || sib.action_type !== 'bundle_fixed_price' || (filled(v) && Number(v) >= 0)
            ),
          },
          // discount — item_discount เท่านั้น
          discount_value: {
            required: helpers.withMessage(
              () => t('_promotion.Enter discount value'),
              (v) => ! isItemDiscount() || (filled(v) && Number(v) >= 0)
            ),
          },
          // target — ทั้งสอง type
          product_id: {
            okWhenProduct: helpers.withMessage(
              () => t('_promotion.Select qualifying product'),
              (v, sib) => sib.scope !== 'product' || filled(v)
            ),
          },
          product_category_id: {
            okWhenCategory: helpers.withMessage(
              () => t('_promotion.Select a category'),
              (v, sib) => sib.scope !== 'category' || filled(v)
            ),
          },
        }),
      },
    },
  };
}
